import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Table, Button } from "react-bootstrap";
import { Tabs, Card, Input } from "antd";
import {
  exportStaffPDF,
  exportStaffExcel,
  exportUserExcel,
  exportUserPDF,
} from "../pdf/PdfandExcel";
import "./listings/Pages.css";

const { TabPane } = Tabs;

const DashboardSummary = ({
  searchText,
  setSearchText,
  selectedStaffId,
  setSelectedStaffId,
  selectedUserId,
  setSelectedUserId,
}) => {
  const { staffGroupedCounts, status, error } = useSelector(
    (state) => state.groupData
  );

  const filteredStaff = staffGroupedCounts?.staff_grouped_counts?.filter(
    (staff) =>
      staff.staff_name.toLowerCase().includes(searchText.toLowerCase()) ||
      staff.staff_no.toLowerCase().includes(searchText.toLowerCase())
  );

  const filteredUsers = staffGroupedCounts?.user_grouped_counts?.filter(
    (user) => user.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const onSearch = (value) => {
    setSearchText(value);
  };

  // Toggle sub-table for staff
  const toggleStaffSubTable = (staffId) => {
    setSelectedStaffId(selectedStaffId === staffId ? null : staffId);
    setSelectedUserId(null);
  };

  // Toggle sub-table for user
  const toggleUserSubTable = (userId) => {
    setSelectedUserId(selectedUserId === userId ? null : userId);
    setSelectedStaffId(null);
  };

  // Staff Total Box Count
const staffTotalBox =
  filteredStaff?.reduce(
    (sum, s) => sum + Number(s.total_count || 0),
    0
  ) || 0;

//  User Total Box Count
const userTotalBox =
  filteredUsers?.reduce(
    (sum, u) => sum + Number(u.total_count || 0),
    0
  ) || 0;

//  Combined Total
const combinedTotalBox = staffTotalBox + userTotalBox;

//  Staff Current Date Paid Total
const staffCurrentDatePaid =
  filteredStaff?.reduce(
    (sum, s) => sum + Number(s.current_date_paid_count || 0),
    0
  ) || 0;

//  User Current Date Paid Total
const userCurrentDatePaid =
  filteredUsers?.reduce(
    (sum, u) => sum + Number(u.current_date_paid_count || 0),
    0
  ) || 0;

const combinedCurrentDatePaid =
  staffCurrentDatePaid + userCurrentDatePaid;


//  Staff Current Month Paid Total
const staffCurrentMonthPaid =
  filteredStaff?.reduce(
    (sum, s) => sum + Number(s.current_month_paid_count || 0),
    0
  ) || 0;

const userCurrentMonthPaid =
  filteredUsers?.reduce(
    (sum, u) => sum + Number(u.current_month_paid_count || 0),
    0
  ) || 0;

const combinedCurrentMonthPaid =
  staffCurrentMonthPaid + userCurrentMonthPaid;


//  Staff Current Month Unpaid Total
const staffCurrentMonthUnpaid =
  filteredStaff?.reduce(
    (sum, s) => sum + Number(s.current_month_unpaid_count || 0),
    0
  ) || 0;

const userCurrentMonthUnpaid =
  filteredUsers?.reduce(
    (sum, u) => sum + Number(u.current_month_unpaid_count || 0),
    0
  ) || 0;

const combinedCurrentMonthUnpaid =
  staffCurrentMonthUnpaid + userCurrentMonthUnpaid;

  return (
    <Tabs defaultActiveKey="staff-summary" tabPosition="top">
      {/* Staff Summary Sub-Tab */}
      <TabPane tab="Staff Summary" key="staff-summary">
        <Card className="recent-activities-card p-2 w-100 ms-2 responsive">
          <div className="py-3 d-flex justify-content-end">
            <Button
              variant="success"
              className="me-2"
              onClick={() => exportStaffPDF(filteredStaff)}
            >
              Export Staff PDF
            </Button>
            <Button
              variant="success"
              onClick={() => exportStaffExcel(filteredStaff)}
            >
              Export Staff Excel
            </Button>
          </div>
          <div
            className="py-3 px-4 w-100 d-flex justify-content-between align-items-center flex-wrap"
            style={{
              backgroundColor: "#f0f0f0",
              borderBottom: "1px solid #d9d9d9",
            }}
          >
            <h3 className="m-0 fw-600">Staff Summary</h3>
            <Input.Search
              placeholder="Search staff..."
              allowClear
              style={{ width: 250, marginTop: "8px" }}
              onSearch={onSearch}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <Table striped bordered hover responsive>
            <thead className="staff_summary_heading">
              <tr>
                <th className="staff_summary_heading">S.No</th>
                <th className="staff_summary_heading">Staff Name</th>
                <th className="staff_summary_heading">Staff No</th>
                <th className="staff_summary_heading">Total Box Count</th>
                <th className="staff_summary_heading">
                  Current Date Paid Box Count
                </th>
                <th className="staff_summary_heading">
                  Current Month Paid Box Count
                </th>
                <th className="staff_summary_heading">
                  Current Month Unpaid Box Count
                </th>
              </tr>
            </thead>
           <tbody>
  {status === "succeeded" && filteredStaff?.length > 0 ? (
    <>
      {filteredStaff.map((staff, index) => (
        <React.Fragment key={staff.staff_id}>
          <tr
            onClick={() => toggleStaffSubTable(staff.staff_id)}
            style={{ cursor: "pointer" }}
          >
            <td>{index + 1}</td>
            <td>{staff.staff_name}</td>
            <td>{staff.staff_no}</td>
            <td>{staff.total_count}</td>
            <td>{staff.current_date_paid_count}</td>
            <td>{staff.current_month_paid_count}</td>
            <td>{staff.current_month_unpaid_count}</td>
          </tr>

          {selectedStaffId === staff.staff_id &&
            staff.areas?.length > 0 && (
              <tr>
                <td colSpan="7">
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th className="staff_area_summary_heading">
                          Area Name
                        </th>
                        <th className="staff_area_summary_heading">
                          Total Box Count
                        </th>
                        <th className="staff_area_summary_heading">
                          Current Date Paid Box Count
                        </th>
                        <th className="staff_area_summary_heading">
                          Current Month Paid Box Count
                        </th>
                        <th className="staff_area_summary_heading">
                          Current Month Unpaid Box Count
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {staff.areas.map((area, index) => (
                        <tr key={index}>
                          <td>{area.area_name}</td>
                          <td>{area.box_count}</td>
                          <td>{area.current_date_paid_count}</td>
                          <td>{area.current_month_paid_count}</td>
                          <td>{area.current_month_unpaid_count}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </td>
              </tr>
            )}
        </React.Fragment>
      ))}

      {/* 🔥 TOTAL ROW */}
     
<tr style={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
  <td colSpan="3" className="text-center">
    TOTAL
  </td>

  <td>{combinedTotalBox}</td>
  <td>{combinedCurrentDatePaid}</td>
  <td>{combinedCurrentMonthPaid}</td>
  <td>{combinedCurrentMonthUnpaid}</td>
</tr>
    </>
  ) : (
    <tr>
      <td colSpan="7" className="text-center">
        No staff found matching the search criteria.
      </td>
    </tr>
  )}
</tbody>
          </Table>
        </Card>
      </TabPane>
      {/* User Summary Sub-Tab */}
      <TabPane tab="User Summary" key="user-summary">
        <Card className="recent-activities-card p-2 w-100 ms-2 responsive">
          <div className="py-3 d-flex justify-content-end">
            <Button
              variant="success"
              className="me-2"
              onClick={() => exportUserPDF(filteredUsers)}
            >
              Export User PDF
            </Button>
            <Button
              variant="success"
              onClick={() => exportUserExcel(filteredUsers)}
            >
              Export User Excel
            </Button>
          </div>
          <div
            className="py-3 px-4 w-100 d-flex justify-content-between align-items-center flex-wrap"
            style={{
              backgroundColor: "#f0f0f0",
              borderBottom: "1px solid #d9d9d9",
            }}
          >
            <h3 className="m-0 fw-600">User Summary</h3>
            <Input.Search
              placeholder="Search user..."
              allowClear
              style={{ width: 250, marginTop: "8px" }}
              onSearch={onSearch}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th className="user_summary_heading">S.No</th>
                <th className="user_summary_heading">User Name</th>
                <th className="user_summary_heading">Total Box Count</th>
                <th className="user_summary_heading">
                  Current Date Paid Box Count
                </th>
                <th className="user_summary_heading">
                  Current Month Paid Box Count
                </th>
                <th className="user_summary_heading">
                  Current Month Unpaid Box Count
                </th>
              </tr>
            </thead>
           <tbody>
  {status === "succeeded" && filteredUsers?.length > 0 ? (
    <>
      {filteredUsers.map((user, index) => (
        <React.Fragment key={user.user_id}>
          <tr
            onClick={() => toggleUserSubTable(user.user_id)}
            style={{ cursor: "pointer" }}
          >
            <td>{index + 1}</td>
            <td>{user.name}</td>
            <td>{user.total_count}</td>
            <td>{user.current_date_paid_count}</td>
            <td>{user.current_month_paid_count}</td>
            <td>{user.current_month_unpaid_count}</td>
          </tr>

          {selectedUserId === user.user_id &&
            user.areas?.length > 0 && (
              <tr>
                <td colSpan="6">
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th className="user_area_summary_heading">
                          Area Name
                        </th>
                        <th className="user_area_summary_heading">
                          Total Box Count
                        </th>
                        <th className="user_area_summary_heading">
                          Current Date Paid Box Count
                        </th>
                        <th className="user_area_summary_heading">
                          Current Month Paid Box Count
                        </th>
                        <th className="user_area_summary_heading">
                          Current Month Unpaid Box Count
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {user.areas.map((area, index) => (
                        <tr key={index}>
                          <td>{area.area_name}</td>
                          <td>{area.box_count}</td>
                          <td>{area.current_date_paid_count}</td>
                          <td>{area.current_month_paid_count}</td>
                          <td>{area.current_month_unpaid_count}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </td>
              </tr>
            )}
        </React.Fragment>
      ))}

      {/* TOTAL ROW */}
     
<tr style={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
  <td colSpan="2" className="text-center">
    TOTAL
  </td>

  <td>{combinedTotalBox}</td>
  <td>{combinedCurrentDatePaid}</td>
  <td>{combinedCurrentMonthPaid}</td>
  <td>{combinedCurrentMonthUnpaid}</td>
</tr>
    </>
  ) : (
    <tr>
      <td colSpan="6" className="text-center">
        No users found matching the search criteria.
      </td>
    </tr>
  )}
</tbody>
          </Table>
        </Card>
      </TabPane>
    </Tabs>
  );
};

export default DashboardSummary;
